import { OnlineTemplate } from "~/entities/templateEntities";
import Client from "../baseClient";
import { getSubdomainFromRequest } from "~/helpers/requestHelpers";

export const TemplateApi = {
  getTemplate: async (request: Request) =>
    await Client.get<OnlineTemplate>(
      `org/${getSubdomainFromRequest(request)}/onlineTemplates/default`,
    ),
};
